import Select from "react-select";
import { useState, useEffect, useCallback } from "react"; // Added useCallback
import { Button, Form } from "react-bootstrap"; // Removed Alert
import axios from "axios";
import SchoolSidebar from "./SchoolSidebar";
import swal from "sweetalert";

const genders = ["Boy", "Girl"];

export default function SchoolUniformForm() {
  const [form, setForm] = useState({
    enrollment: "",
    group: "",
    gender: "",
    grade: "",
    name: "",
    student: "",
    products: [],
    height: "",
    schoolId: localStorage.getItem("schoolID"),
  });
  const [products, setProducts] = useState([]);
  const [mode, setMode] = useState("");
  const [enrollmentNumbers, setEnrollmentNumbers] = useState([]);
  const [studentNames, setStudentNames] = useState([]);
  const [grades, setGrades] = useState([]);
  const [gorb, setGorB] = useState([]);
  const [data, setData] = useState([]);
  const [gOrbData, setGorbData] = useState([]);
  const [size_guide, setSizeGuide] = useState([]);
  const [sockGuides, setSockGuides] = useState([]);
  const [trackGuide, setTrackGuide] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const OUT_OF_RANGE = "OUT_OF_RANGE";

  // Logic for calculations moved into useCallback to stabilize dependencies
  const calculateSuggestionLogic = useCallback(
    (productId, index, type, primarySizeValue) => {
      const sockSize = sockGuides?.size_guide?.[productId];
      if (sockSize) return sockSize;

      if (index === 0 || !primarySizeValue) return "";

      const guides = size_guide?.filter((g) => g.styleType === type) || [];

      for (let g of guides) {
        if (g.mappingData.primarySize === primarySizeValue) {
          const equivalent = g.mappingData?.equivalentSizes?.[productId];

          if (equivalent) {
            let suffix = "";
            const product =
              products.bottomwear?.find((p) => p.productId === productId) ||
              products.topwear?.find((p) => p.productId === productId) ||
              products.combined?.find((p) => p.productId === productId);

            const matchedTrackGuide = trackGuide?.find(
              (tg) => String(tg.category._id) === String(product?.category),
            );

            if (matchedTrackGuide && form.height) {
              const numericHeight = Number(form.height);
              const rule = matchedTrackGuide.sizeRules?.find(
                (r) => String(r.baseSize) === String(equivalent),
              );

              if (rule) {
                const range = rule.ranges?.find(
                  (rg) => numericHeight >= rg.min && numericHeight <= rg.max,
                );
                if (!range) return OUT_OF_RANGE;
                suffix = range.suffix || "";
              }
            }
            return equivalent + suffix;
          }
        }
      }
      return "";
    },
    [sockGuides, size_guide, products, trackGuide, form.height],
  );

  const getSuggestedSize = useCallback(
    (productId, index, type) => {
      const list = type === "Topwear" ? products.topwear : products.bottomwear;
      if (!list?.length) return "";
      const primaryProduct = list[0];
      const primarySelectedVariantId = form.products?.find(
        (p) => p.productId === primaryProduct.productId,
      )?.variantId;
      const primarySelectedSizeObj = primaryProduct.sizes?.find(
        (s) => s.variantId === primarySelectedVariantId,
      );

      return calculateSuggestionLogic(
        productId,
        index,
        type,
        primarySelectedSizeObj?.size,
      );
    },
    [products, form.products, calculateSuggestionLogic],
  );

  useEffect(() => {
    const fetchSchool = async () => {
      try {
        const schoolId = localStorage.getItem("schoolID");
        const resp = await axios.get(
          `/api/schooluniform/get-students-by-school/${schoolId}`,
        );
        const students = resp.data.data;
        const gOrb = resp.data.gOrb;

        setEnrollmentNumbers(students.map((s) => s.enrollment_number));
        setStudentNames(students.map((s) => s.name));

        const uniqueGrades = Array.from(
          new Map(
            students.map((s) => [
              s.grade?._id,
              { id: s.grade?._id, name: s.grade?.name },
            ]),
          ).values(),
        );

        setGrades(uniqueGrades);
        setData(students);
        console.log("GOrb Data:", gOrb);
        setGorbData(gOrb);
        setGorB(gOrb);
        setMode(resp.data.option);
      } catch (err) {
        console.error(err);
      }
    };
    fetchSchool();
  }, []);

  useEffect(() => {
    const fetchTrackGuides = async () => {
      try {
        const res = await axios.get(`/api/track-guides`);
        setTrackGuide(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchTrackGuides();
  }, []);

  useEffect(() => {
    if (!form.grade || !grades.length) return;

    const fetchSockGuides = async () => {
      try {
        const schoolId = localStorage.getItem("schoolID");
        const res = await axios.get(`/api/socks-guide/school/${schoolId}`);
        const mappingData = res.data?.[0]?.mappingData || [];

        const selectedGrade = grades.find((g) => g.id === form.grade);

        const gradeMapping = mappingData.find(
          (item) =>
            item.grade?.trim().toLowerCase() ===
            selectedGrade?.name?.trim().toLowerCase(),
        );

        setSockGuides(gradeMapping || {});
      } catch (err) {
        console.error(err);
      }
    };
    fetchSockGuides();
  }, [form.grade, grades]);

  // Server-side name filter
  useEffect(() => {
    const fetchFilteredStudentNames = async () => {
      try {
        const schoolId = localStorage.getItem("schoolID");
        const resp = await axios.get("/api/schooluniform/filter-studentnames", {
          params: {
            schoolId,
            gender: form.gender ? form.gender.toLowerCase() : "",
            grade: form.grade || "",
          },
        });
        setStudentNames(resp.data.data);
      } catch (err) {
        console.error("Failed to fetch student names:", err);
      }
    };

    fetchFilteredStudentNames();
  }, [form.gender, form.grade]);

  // Duplicate check
  useEffect(() => {
    if (!form.enrollment) return;

    const checkUniformExists = async () => {
      try {
        const res = await axios.get(
          `/api/schooluniform/exists?enrollment=${form.enrollment}`,
        );
        if (res.data.exists) {
          swal({
            title: "Already Filled",
            text: "Uniform already exists for this student. Please go and edit.",
            icon: "warning",
            button: "OK",
          });
        }
      } catch (err) {
        console.error("Uniform check failed:", err);
      }
    };

    checkUniformExists();
  }, [form.enrollment]);

  // FIXED: Added missing dependencies after stabilizing getSuggestedSize
  useEffect(() => {
    if (mode === "bundle" && form.height) {
      setForm((prev) => ({
        ...prev,
        products: prev.products.map((p) => {
          const type = products.topwear?.find(
            (t) => t.productId === p.productId,
          )
            ? "Topwear"
            : "Bottomwear";
          const index = products[
            type === "Topwear" ? "topwear" : "bottomwear"
          ]?.findIndex((item) => item.productId === p.productId);

          const suggestion = getSuggestedSize(p.productId, index, type);

          if (suggestion === OUT_OF_RANGE) {
            return { ...p, variantId: "" }; // Reset dropdown
          }
          return p;
        }),
      }));
    }
  }, [form.height, mode, products, getSuggestedSize]);

  const hasOutOfRangeError = () => {
    // Check Topwear
    const topOutOfRange = products.topwear?.some(
      (p, index) =>
        getSuggestedSize(p.productId, index, "Topwear") === OUT_OF_RANGE,
    );

    // Check Bottomwear
    const bottomOutOfRange = products.bottomwear?.some(
      (p, index) =>
        getSuggestedSize(p.productId, index, "Bottomwear") === OUT_OF_RANGE,
    );

    return topOutOfRange || bottomOutOfRange;
  };

  // Unified useEffect for bidirectional sync and gorb filtering
  useEffect(() => {
    if (!form.gender || !form.grade || !form.student) return;

    // Auto-fill enrollment
    const matchedStudent = data.find(
      (s) =>
        s.name === form.student &&
        s.gender === form.gender.toLowerCase() &&
        s.grade._id === form.grade,
    );

    if (
      matchedStudent &&
      form.enrollment !== matchedStudent.enrollment_number
    ) {
      setForm((prev) => ({
        ...prev,
        enrollment: matchedStudent.enrollment_number,
      }));
    }

    const gOrbList = Array.from(
      new Map(
        gOrbData
          .filter(
            (g) =>
              g.gender === form.gender.toLowerCase() &&
              g.grades.includes(form.grade) &&
              matchedStudent &&
              (!g.house ||
                g.house?.toString() === matchedStudent.house?.toString()),
          )
          .map((s) => [s._id, { _id: s._id, name: s.name }]),
      ).values(),
    );

    setGorB(gOrbList);

    if (gOrbList.length > 0 && form.group !== gOrbList[0]._id) {
      setForm((prev) => ({
        ...prev,
        group: gOrbList[0]._id,
      }));
    }
  }, [
    form.gender,
    form.grade,
    form.student,
    data,
    gOrbData,
    form.enrollment,
    form.group,
  ]);

  // Filter gorb by grade only
  useEffect(() => {
    if (!form.grade) return;
    const gOrbList = Array.from(
      new Map(
        gOrbData
          .filter((g) => g.grades.includes(form.grade))
          .map((s) => [s._id, { _id: s._id, name: s.name }]),
      ).values(),
    );

    setGorB(gOrbList);
  }, [form.grade, gOrbData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({ ...prev, [name]: value }));

    if (name === "enrollment" && value) {
      const selectedStudent = data.find((s) => s.enrollment_number === value);

      if (selectedStudent) {
        const genderLower = selectedStudent.gender.toLowerCase();
        const gradeId = selectedStudent.grade._id;

        const matchedGorb = gOrbData.filter(
          (g) =>
            g.gender === genderLower &&
            g.grades.includes(gradeId) &&
            (!g.house ||
              g.house.toString() === selectedStudent.house.toString()),
        );

        setForm((prev) => ({
          ...prev,
          student: selectedStudent.name,
          gender: genderLower.charAt(0).toUpperCase() + genderLower.slice(1),
          grade: gradeId,
          group: matchedGorb.length > 0 ? matchedGorb[0]._id : "",
        }));

        setGorB(matchedGorb);
      }
    }
  };

  const handleSizeChange = (productId, variantId) => {
    setForm((prev) => {
      let updatedProducts = prev.products.map((p) =>
        p.productId === productId ? { ...p, variantId } : p,
      );

      if (mode === "bundle") {
        const topPrimary = products.topwear?.[0];
        const bottomPrimary = products.bottomwear?.[0];
        let listToAutoFill = [];
        let type = "";

        if (topPrimary && productId === topPrimary.productId) {
          listToAutoFill = products.topwear;
          type = "Topwear";
        } else if (bottomPrimary && productId === bottomPrimary.productId) {
          listToAutoFill = products.bottomwear;
          type = "Bottomwear";
        }

        if (listToAutoFill.length > 0) {
          const primarySizeValue = listToAutoFill[0].sizes.find(
            (s) => s.variantId === variantId,
          )?.size;
          if (primarySizeValue) {
            updatedProducts = updatedProducts.map((p) => {
              const indexInList = listToAutoFill.findIndex(
                (item) => item.productId === p.productId,
              );
              if (indexInList <= 0) return p;

              const suggestion = calculateSuggestionLogic(
                p.productId,
                indexInList,
                type,
                primarySizeValue,
              );

              if (suggestion && suggestion !== OUT_OF_RANGE) {
                const targetProduct = listToAutoFill.find(
                  (item) => item.productId === p.productId,
                );
                const matchedVariant = targetProduct?.sizes?.find(
                  (s) => s.size === suggestion,
                );

                if (matchedVariant)
                  return { ...p, variantId: matchedVariant.variantId };
              }

              // If out of range, clear variantId
              if (suggestion === OUT_OF_RANGE) return { ...p, variantId: "" };
              return p;
            });
          }
        }
      }

      return { ...prev, products: updatedProducts };
    });
  };

  const handleQuantityChange = (productId, qty, min, max) => {
    let value = qty;

    // allow clearing the input
    if (Number.isNaN(value)) value = "";

    // apply limits only when both are not 0
    if (!(min === 0 && max === 0) && value !== "") {
      if (min !== undefined && value < min) value = min;
      if (max !== undefined && value > max) value = max;
    }

    setForm((prev) => ({
      ...prev,
      products: prev.products.map((p) =>
        p.productId === productId ? { ...p, quantity: value } : p,
      ),
    }));
  };

  const getProducts = async () => {
    if (!form.group) {
      return swal(
        "Missing Selection",
        `Please select a ${mode === "group" ? "Group" : "Bundle"} first.`,
        "warning",
      );
    }
    try {
      const url =
        mode === "group"
          ? "/api/schooluniform/products-by-group"
          : "/api/schooluniform/products-by-bundle";
      const resp = await axios.get(url, { params: { gOrbId: form.group } });
      setSizeGuide(resp.data.size_guide);
      setProducts(resp.data.products);

      const {
        topwear = [],
        bottomwear = [],
        combined = [],
      } = resp.data.products;
      const allProducts =
        combined.length > 0 ? combined : [...topwear, ...bottomwear];

      setForm((prev) => ({
        ...prev,
        products: allProducts.map((p) => ({
          productId: p.productId,
          variantId: "",
          quantity:
            mode === "group"
              ? (p.min_quantity === 0 && p.max_quantity === 0 ? 0 : p.min_quantity)
              : p.quantity ?? p.min_quantity ?? 0,
        })),
      }));
    } catch (err) {
      swal("Error", "Failed to fetch products.", "error");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (mode === "bundle") {
      const hasInvalid = form.products.some((p) => !p.variantId);
      if (hasInvalid)
        return swal(
          "Validation Error",
          "Please select all valid sizes.",
          "warning",
        );
    }

    try {
      setIsSubmitting(true);
      await axios.post("/api/schooluniform/create", { ...form, mode });
      swal("Success!", "Form submitted successfully.", "success");
      setForm({
        enrollment: "",
        student: "",
        gender: "",
        grade: "",
        group: "",
        products: [],
        height: "",
        schoolId: localStorage.getItem("schoolID"),
      });
      setProducts([]);
    } catch (err) {
      swal(
        "Error",
        err.response?.data?.message || "Something went wrong!",
        "error",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Helper to render table rows
  const renderProductRows = (productList, type) => {
    return productList.map((p, index) => {
      const formProduct = form.products.find(
        (fp) => fp.productId === p.productId,
      );
      const suggestedSize = getSuggestedSize(p.productId, index, type);
      const isOutOfRange = suggestedSize === OUT_OF_RANGE;

      return (
        <tr key={p.productId} className={isOutOfRange ? "table-danger" : ""}>
          <td>{p.name}</td>
          <td>
            {isOutOfRange ? (
              <span className="text-danger fw-bold">
                No variant available for this height
              </span>
            ) : (
              suggestedSize || "-"
            )}
          </td>
          <td>
            <Form.Select
              value={formProduct?.variantId || ""}
              onChange={(e) => handleSizeChange(p.productId, e.target.value)}
              disabled={isOutOfRange} // FEATURE: Disable dropdown if out of range
            >
              <option value="" disabled>
                Select size
              </option>
              {p.sizes?.map((s) => (
                <option key={s.variantId} value={s.variantId}>
                  {s.size}
                </option>
              ))}
            </Form.Select>
          </td>
          <td>
            <Form.Control
              type="number"
              min={
                p.min_quantity === 0 && p.max_quantity === 0
                  ? undefined
                  : p.min_quantity
              }
              max={
                p.min_quantity === 0 && p.max_quantity === 0
                  ? undefined
                  : p.max_quantity
              }
              value={formProduct?.quantity ?? ""}
              onChange={(e) =>
                handleQuantityChange(
                  p.productId,
                  Number(e.target.value),
                  p.min_quantity,
                  p.max_quantity,
                )
              }
            />
          </td>
        </tr>
      );
    });
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <SchoolSidebar />
      <div className="container mt-5 p-3 shadow-lg rounded-4 bg-light border mb-4">
        <div style={{ width: "90%", margin: "0 auto" }}>
          <h3 className="mb-4 text-center fw-bold text-primary">
            Student Selection Form
          </h3>
          <Form className="bg-white p-4 rounded-3 shadow-sm">
            {/* Enrollment - Single Row */}
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Enrollment No</Form.Label>
                <Select
                  options={enrollmentNumbers.map((e) => ({
                    label: e,
                    value: e,
                  }))}
                  value={
                    form.enrollment
                      ? { label: form.enrollment, value: form.enrollment }
                      : null
                  }
                  onChange={(s) =>
                    handleChange({
                      target: { name: "enrollment", value: s ? s.value : "" },
                    })
                  }
                  isClearable
                />
              </Form.Group>
            </div>
            <div className="text-center fw-bold">OR</div>
            {/* Bundle/Group + Gender */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Select {mode === "group" ? "Group" : "Bundle"}
                  </Form.Label>
                  <Select
                    name="group"
                    placeholder={`Select ${mode === "group" ? "Group" : "Bundle"}`}
                    isSearchable
                    isClearable
                    options={gorb.map((item) => ({
                      label: item.name,
                      value: item._id,
                    }))}
                    value={
                      form.group
                        ? {
                            label:
                              gorb.find((g) => g._id === form.group)?.name ||
                              "",
                            value: form.group,
                          }
                        : null
                    }
                    onChange={(selected) =>
                      handleChange({
                        target: {
                          name: "group",
                          value: selected ? selected.value : "",
                        },
                      })
                    }
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Select Gender</Form.Label>
                  <Form.Select
                    name="gender"
                    value={form.gender}
                    onChange={handleChange}
                    disabled={form.enrollment !== ""}
                  >
                    <option>Select Gender</option>
                    {genders.map((g) => (
                      <option key={g} value={g}>
                        {g}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
            {/* Grade + Student Name */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Select Grade</Form.Label>
                  <Form.Select
                    name="grade"
                    value={form.grade}
                    onChange={handleChange}
                    disabled={form.enrollment !== ""}
                  >
                    <option>Select Grade</option>
                    {grades.map((g) => (
                      <option key={g.id} value={g.id}>
                        {g.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Student Name</Form.Label>
                  <Select
                    name="student"
                    placeholder="Type or select student"
                    isSearchable
                    isClearable
                    isDisabled={form.enrollment !== ""}
                    options={studentNames?.map((name) => ({
                      label: name,
                      value: name,
                    }))}
                    value={
                      form.student
                        ? { label: form.student, value: form.student }
                        : null
                    }
                    onChange={(selected) =>
                      handleChange({
                        target: {
                          name: "student",
                          value: selected ? selected.value : "",
                        },
                      })
                    }
                  />
                </Form.Group>
              </div>
            </div>
            {/* Height */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Height (cm)</Form.Label>
                  <Form.Control
                    type="number"
                    name="height"
                    placeholder="Enter height"
                    value={form.height}
                    onChange={handleChange}
                    min={1}
                  />
                </Form.Group>
              </div>
            </div>
            <Button variant="outline-primary" onClick={getProducts}>
              Get Products
            </Button>
          </Form>
          {/* Tables */}
          {Object.keys(products).length > 0 && (
            <div className="mt-4">
              {products.topwear?.length > 0 && (
                <div className="mb-4">
                  <h5 className="text-primary">Top Wear</h5>
                  <table className="table table-bordered bg-white">
                    <thead className="table-light">
                      <tr>
                        <th>Product</th>
                        <th>Suggested Size</th>
                        <th>Size</th>
                        <th>Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderProductRows(products.topwear, "Topwear")}
                    </tbody>
                  </table>
                </div>
              )}
              {products.bottomwear?.length > 0 && (
                <div className="mb-4">
                  <h5 className="text-primary">Bottom Wear</h5>
                  <table className="table table-bordered bg-white">
                    <thead className="table-light">
                      <tr>
                        <th>Product</th>
                        <th>Suggested Size</th>
                        <th>Size</th>
                        <th>Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderProductRows(products.bottomwear, "Bottomwear")}
                    </tbody>
                  </table>
                </div>
              )}
              {products.combined?.length > 0 &&
                products.topwear?.length === 0 && (
                  <div className="mb-4">
                    <h5 className="text-primary">Products</h5>
                    <table className="table table-bordered bg-white">
                      <thead className="table-light">
                        <tr>
                          <th>Product</th>
                          <th>Suggested Size</th>
                          <th>Size</th>
                          <th>Qty</th>
                        </tr>
                      </thead>
                      <tbody>{renderProductRows(products.combined, "")}</tbody>
                    </table>
                  </div>
                )}
            </div>
          )}
          <div className="text-end mt-3 mb-5">
            <Button
              variant="primary"
              size="lg"
              onClick={handleSubmit}
              // New logic: Disable if submitting OR if any product is out of range
              disabled={isSubmitting || hasOutOfRangeError()}
            >
              {isSubmitting ? "Submitting..." : "Submit Order"}
            </Button>
            {/* Optional: Add a small warning text */}
            {hasOutOfRangeError() && (
              <div className="text-danger mt-2">
                Cannot submit: Some items are out of range for this height.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
